import React from 'react';
import './styles.scss';

interface SummaryBadgeProps {
    variant: 'when' | 'then' | 'else';
    children: React.ReactNode;
}

const SummaryBadge = ({ variant, children }: SummaryBadgeProps) => (
    <span className={`rb-summary-badge rb-summary-badge--${variant}`}>{children}</span>
);

export default SummaryBadge;
